import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, FileText, Sparkles, LayoutTemplate, User } from 'lucide-react';

const MobileNavigation = () => {
  const location = useLocation();
  
  const navItems = [
    { path: '/dashboard', icon: Home, label: 'Inicio' },
    { path: '/templates', icon: LayoutTemplate, label: 'Plantillas' },
    { path: '/recommend', icon: Sparkles, label: 'Asistente' },
    { path: '/contracts', icon: FileText, label: 'Contratos' },
  ];

  // Don't show on landing or auth pages
  if (['/', '/auth', '/login', '/register'].includes(location.pathname)) {
    return null;
  }

  return (
    <nav className="mobile-nav md:hidden" data-testid="mobile-nav">
      {navItems.map((item) => {
        const isActive = location.pathname === item.path || 
                        (item.path === '/contracts' && location.pathname.startsWith('/contract/')) ||
                        (item.path === '/dashboard' && location.pathname === '/dashboard');
        
        return (
          <Link
            key={item.path}
            to={item.path}
            className={`mobile-nav-item ${isActive ? 'active' : ''}`}
            data-testid={`mobile-nav-${item.label.toLowerCase()}`}
          >
            <item.icon />
            <span>{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default MobileNavigation;
